import { IMAGE_ACCEPT, IMAGE_OR_PDF_ACCEPT, MEDIA_ACCEPT, MEDIA_OR_PDF_ACCEPT } from "../upload-constraints";
import type { FileUploadDefinition } from "../types";

export const referenceSpotUrls = ["https://creatrip.com/en/spot/15621", "https://creatrip.com/en/spot/15494", "https://creatrip.com/en/spot/15221", "https://creatrip.com/en/spot/15175"];
const MAX_FILES_PER_UPLOAD = 10;
export const MAX_LISTING_PHOTOS = 30;

export const PHOTO_UPLOADS: FileUploadDefinition[] = [
  {
    id: "heroImage",
    category: "hero_image",
    label: "대표사진",
    description: "상품 대표사진으로 사용할 이미지 1장을 첨부해주세요. 대표사진은 상품 썸네일이기도 하니, 고객이 가장 눌러보고 싶을 만한 색감·톤·구성·인물 사진을 우선 추천합니다. 권장 비율은 1200×935이며, UI 위치에 따라 가장자리가 잘릴 수 있습니다.",
    accept: IMAGE_ACCEPT,
    required: true,
    maxFiles: 1,
  },
  {
    id: "listingPhotos",
    category: "listing_photo",
    label: "상품 페이지 등재 사진 / 영상",
    description: "상단에는 대표사진 + 보조사진 4개만 먼저 보이지만, ‘전체보기’ 갤러리에서는 최대 30개까지 노출됩니다. 다양한 각도·공간·진행 장면을 10장 이상 첨부하면 상품 페이지가 훨씬 풍성해집니다. 사진은 가로형을 권장합니다.",
    accept: MEDIA_ACCEPT,
    multiple: true,
    required: true,
    maxFiles: MAX_LISTING_PHOTOS,
  },
  {
    id: "interiorExterior",
    category: "interior_exterior",
    label: "매장 내부 / 외부 사진 / 영상",
    description: "입구, 로비, 상담실, 시술실, 찾아오는 길 안내에 도움이 되는 사진이나 짧은 영상을 첨부해주세요.",
    accept: MEDIA_ACCEPT,
    multiple: true,
    required: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "treatmentPhotos",
    category: "treatment_photo",
    label: "시술 사진 / 영상 또는 시술 기기 자료",
    description: "시술 장면이나 장비/기기 사진·영상 중 준비된 자료를 첨부해주세요. 파일명에 어떤 시술/장비 자료인지 꼭 표기해주세요. 예: whitening-machine.jpg, lifting-before-care.mp4",
    accept: MEDIA_ACCEPT,
    multiple: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "beforeAfterPhotos",
    category: "before_after_photo",
    label: "전후 비교 사진 / 영상",
    description: "전/후를 각각 낱장으로 올리거나, 한 장에 전후가 함께 배치된 이미지·영상을 올려도 됩니다. 파일명에 어떤 시술이나 서비스에 대한 전후 자료인지 꼭 표기해주세요.\n실제 페이지에서는 아래 예시처럼 노출됩니다.",
    accept: MEDIA_ACCEPT,
    multiple: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "modelPhotos",
    category: "model_photo",
    label: "모델 / 홍보 이미지 / 영상",
    description: "모델 사진, 브랜드 화보, 홍보 이미지나 짧은 영상이 있다면 첨부해주세요.",
    accept: MEDIA_ACCEPT,
    multiple: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "logo",
    category: "logo",
    label: "로고",
    description: "로고 파일이 있다면 첨부해주세요.",
    accept: IMAGE_ACCEPT,
    multiple: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "marketingAssets",
    category: "marketing_asset",
    label: "기타 홍보 자료",
    description: "브로슈어, 소개서, 메뉴판, 영상 등 참고 가능한 자료를 첨부해주세요.",
    accept: MEDIA_OR_PDF_ACCEPT,
    multiple: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
];

export const DOCUMENT_UPLOADS: FileUploadDefinition[] = [
  {
    id: "businessRegistration",
    category: "business_registration",
    label: "사업자등록증 사본",
    description: "계약 및 거래처 등록에 필요한 사업자등록증 사본을 첨부해주세요.",
    accept: IMAGE_OR_PDF_ACCEPT,
    multiple: true,
    required: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "medicalTourismCertificate",
    category: "medical_tourism_certificate",
    label: "외국인유치의료기관 등록증 사본",
    description: "의료기관 입점 시 필요한 외국인유치의료기관 등록증 사본을 첨부해주세요.",
    accept: IMAGE_OR_PDF_ACCEPT,
    multiple: true,
    required: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "bankbookCopy",
    category: "bankbook_copy",
    label: "정산용 통장 사본",
    description: "선택 항목입니다. 편의상 최초 거래처 등록 시 받을 수 있지만, 지금 준비되지 않았다면 첫 정산 시 전달해주셔도 괜찮습니다.",
    accept: IMAGE_OR_PDF_ACCEPT,
    multiple: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
  {
    id: "otherDocuments",
    category: "other_document",
    label: "기타 서류",
    description: "추가로 공유할 서류가 있다면 첨부해주세요.",
    accept: IMAGE_OR_PDF_ACCEPT,
    multiple: true,
    maxFiles: MAX_FILES_PER_UPLOAD,
  },
];
